import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-38bdf21b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer__inner container--large" }, [
  /*#__PURE__*/_createElementVNode("small", { class: "footer__copyright" }, [
    /*#__PURE__*/_createTextVNode(" Made with "),
    /*#__PURE__*/_createElementVNode("span", { class: "text--red" }, "♥"),
    /*#__PURE__*/_createTextVNode(" by Nattaphong Kosakul ")
  ])
], -1))
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, _hoisted_3))
}